export default __webpack_public_path__ + "static/media/nba.71703564.png";